<template>
  <main class="tags">
    <div class="tags__column">
      <div class="tags__list" v-for="(list, key) in listForColumn(tagLists, 0)" :key="`list${key}`">
        <h3 v-html="list.letter"></h3>
        <ul>
          <li v-for="(tag, key) in list.tags" :key="`tag${key}`">
            <router-link :to="`/tags/${tag.slug}`" v-html="tag.name"></router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="tags__column">
      <div class="tags__list" v-for="(list, key) in listForColumn(tagLists, 1)" :key="`list${key}`">
        <h3 v-html="list.letter"></h3>
        <ul>
          <li v-for="(tag, key) in list.tags" :key="`tag${key}`">
            <router-link :to="`/tags/${tag.slug}`" v-html="tag.name"></router-link>
          </li>
        </ul>
      </div>
    </div>
  </main>
</template>

<script>
import ApiPage from '@/services/ApiPage'
export default {
  name: 'Tags',
  extends: ApiPage,
  data() {
    return {
      payload: null,
      tagLists: []
    }
  },
  watch: {
    'payload.tags': function(newVal) {
      let listObj = {
        letter: '0 - 9',
        tags: []
      }
      newVal.forEach((tag) => {
        // Add numbers first
        if (/^[0-9]/.test(tag.name.charAt(0))) {
          listObj.tags.push(tag)
        } else {
          // Add characters
          if (tag.name.charAt(0).toLowerCase() === listObj.letter.toLowerCase()) {
            listObj.tags.push(tag)
          } else {
            // add existing list
            this.tagLists.push(listObj)

            // create new list
            listObj = {
              letter: tag.name.charAt(0).toUpperCase(),
              tags: []
            }
            listObj.tags.push(tag)
          }
        }
      })
    }
  },
  methods: {
    listForColumn(list, columnKey) {
      let columnNum = Math.ceil(list.length / 2)
      return list.filter((item, index) => {
        // save into first column
        if (columnKey === 0 && index <= columnNum) return true

        // save into second column
        if (columnKey === 1 && index > columnNum) return true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tags {
  @include page;
  display:flex;
  flex-wrap:wrap;
  align-items: flex-start;
  &__column {
    width:50%;
    text-align:right;
    .tags__list {
      margin:0 0 2rem 0;
      h3 {
        font-size: $heading;
      }
      ul {
        li {
          a {
            font-size: $heading;
          }
        }
      }
    }
  }
  @media screen and (max-width: $mobile) {
    &__column {
      width:100%;
      .tags__list {
        position: relative;
        h3 {
          font-size:$body--m;
          position: absolute;
          left:0px;
          top:0px;
          height: 1.5rem;
          line-height: 1.5rem;
        }
        ul {
          li {
            a {
              font-size: $body--m;
            }
          }
        }
      }
    }
  }
}
</style>
